(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/cart-icon
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @kind component
 * @overview Cart icon with dynamically updated totals count.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("cart-icon") === undefined) {
    class CartIcon extends HTMLElement {
        constructor(){
            super();
            document.addEventListener("cart:updated", this.cartUpdated.bind(this));
        }
        cartUpdated() {
            fetch(`?section_id=${this.dataset.section}`).then((response)=>response.text()).then((responseText)=>{
                const cartIcon = this.localName;
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.querySelector(cartIcon);
                const source = html.querySelector(cartIcon);
                if (source && destination) destination.innerHTML = source.innerHTML;
            });
        }
    }
    customElements.define("cart-icon", CartIcon);
}



})();
